// @ts-nocheck
import Download from "@store/Library/Components/Icons/Download";
import translate from "@insite/client-framework/Translate";
import { ProductDto } from "@insite/client-framework/Types/ApiModels";
import Accordion from "@insite/mobius/Accordion";
import AccordionSection from "@insite/mobius/AccordionSection";
import { ButtonIcon } from "@insite/mobius/Button";
import GridItem from "@insite/mobius/GridItem";
import { Button, GridContainer, Typography } from "@insite/mobius/index";
import getColor from "@insite/mobius/utilities/getColor";
import FileUploadField from "@store/Library/Components/BuyingList/FileUploadField";
import FadeIn from "@store/Library/Components/Reporting/Common/FadeIn";
import accordionStyles from "@store/Themes/common/styleguide/components/accordion";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { useState } from "react";
import { css } from "styled-components";

interface ManageModalUploadAccordianProps {
    handleUpload: (products: ProductDto[]) => Promise<void>;
}
const ManageModalUploadAccordian: React.FC<ManageModalUploadAccordianProps> = ({ handleUpload }) => {
    const [isAccordianOpen, setIsAccordianOpen] = useState(false);
    const downloadTemplateHandler = () => {
        window.open(`${window.location.origin}/UserFiles/templates/ProductUploadTemplate.xlsx`);
    };
    return (
        <Accordion
            onDragOver={() => {
                if (!isAccordianOpen) {
                    setIsAccordianOpen(true);
                }
            }}
            css={css`
                width: 100%;
            `}
            headingLevel={4}
        >
            <AccordionSection
                expanded={isAccordianOpen}
                onTogglePanel={() => setIsAccordianOpen(!isAccordianOpen)}
                css={css`
                    width: 100%;
                `}
                // changing header hover styles somehow overrides the background color and
                // must be reset
                panelProps={{
                    css: css`
                        padding-block: 2rem;
                    `,
                }}
                headerProps={{
                    css: css`
                        ${accordionStyles?.sectionDefaultProps?.headerProps?.css}
                    `,
                }}
                titleTypographyProps={{
                    variant: "h4",
                }}
                title={translate("Upload products from a file")}
            >
                <FadeIn animate={isAccordianOpen}>
                    <GridContainer gap={2}>
                        <GridItem
                            css={css`
                                margin-bottom: 0;
                                flex-direction: column;
                                gap: 2.5rem;
                                justify-content: center;
                                align-items: center;
                            `}
                            width={[12, 12, 6, 6, 6]}
                        >
                            <Typography
                                css={css`
                                    font-size: 1.125rem;
                                    max-width: 75%;
                                `}
                            >
                                {translate(
                                    `Upload an Excel (.xls or .xlsx) or CSV (Comma-Separated Values) file to quickly add product(s) to your list.`,
                                )}
                            </Typography>
                            <Button
                                onClick={downloadTemplateHandler}
                                icon={{
                                    src: Download,
                                    position: "left",
                                }}
                                css={css`
                                    display: flex;
                                    align-items: center;
                                    margin-bottom: ${pxToRem(15)};
                                    ${ButtonIcon} {
                                        color: ${getColor("primary")};
                                    }
                                    > * {
                                        top: 0 !important;
                                    }
                                `}
                                variant="tertiary"
                            >
                                {translate("Download Template")}
                            </Button>
                        </GridItem>
                        <GridItem width={[12, 12, 6, 6, 6]}>
                            <FileUploadField onUpload={handleUpload} />
                        </GridItem>
                    </GridContainer>
                </FadeIn>
            </AccordionSection>
        </Accordion>
    );
};

export default ManageModalUploadAccordian;
